import Vue from 'vue'
import VueRouter from 'vue-router'
import { setRouter } from '@/utils/uni'

Vue.use(VueRouter)

/**
 * 路由由 pages.json 转换而来。
 * Tab 页面（底部导航栏）与普通页面采用同一级路由，
 * 底部 TabBar 由各页面内部的 <footer> 组件自行渲染。
 */
const routes = [
  // 默认跳转首页
  { path: '/', redirect: '/pages/index/index' },

  // ── Tab 页面 ────────────────────────────────────────────────
  { path: '/pages/index/index',   component: () => import('@/pages/index/index.vue') },
  { path: '/pages/task/list',     component: () => import('@/pages/task/list.vue') },
  { path: '/pages/task/orders',   component: () => import('@/pages/task/orders.vue') },
  { path: '/pages/income/index',  component: () => import('@/pages/income/index.vue') },
  { path: '/pages/music/index',   component: () => import('@/pages/music/index.vue') },
  { path: '/pages/market/market', component: () => import('@/pages/market/market.vue') },
  { path: '/pages/hy/contract',   component: () => import('@/pages/hy/contract.vue') },
  { path: '/pages/assets/assets', component: () => import('@/pages/assets/assets.vue') },

  // ── 演唱会 / 音乐 ────────────────────────────────────────────
  { path: '/pages/concert/detail', component: () => import('@/pages/concert/detail.vue') },
  { path: '/pages/concert/trade', component: () => import('@/pages/concert/trade.vue') },

  // ── 用户中心 ─────────────────────────────────────────────────
  // { path: '/pages/user/user',                 component: () => import('@/pages/user/user.vue') },
  { path: '/pages/user/bankCard',             component: () => import('@/pages/user/bankCard.vue') },
  { path: '/pages/user/bindBankCard',         component: () => import('@/pages/user/bindBankCard.vue') },
  { path: '/pages/user/iwannashare',          component: () => import('@/pages/user/iwannashare.vue') },
  // { path: '/pages/user/userInfo',             component: () => import('@/pages/user/userInfo.vue') },
  { path: '/pages/user/securityVerification', component: () => import('@/pages/user/securityVerification.vue') },
  { path: '/pages/user/accountChange',        component: () => import('@/pages/user/accountChange.vue') },
  { path: '/pages/user/authentication',       component: () => import('@/pages/user/authentication.vue') },
  { path: '/pages/user/helpCenter',           component: () => import('@/pages/user/helpCenter.vue') },
  { path: '/pages/user/language',             component: () => import('@/pages/user/language.vue') },
  { path: '/pages/user/themeModel',           component: () => import('@/pages/user/themeModel.vue') },
  { path: '/pages/user/record',               component: () => import('@/pages/user/record.vue') },
  { path: '/pages/user/vip',                  component: () => import('@/pages/user/vip.vue') },
  { path: '/pages/user/paymentMethods',      component: () => import('@/pages/user/paymentMethods.vue') },

  // ── 钱包 ─────────────────────────────────────────────────────
  { path: '/pages/wallet/wallets',     component: () => import('@/pages/wallet/wallets.vue') },
  { path: '/pages/wallet/bindAddress', redirect: '/pages/user/paymentMethods' },

  // ── 提现 ─────────────────────────────────────────────────────
  { path: '/pages/withdraw/withdrawPage', component: () => import('@/pages/withdraw/withdrawPage.vue') },


  // ── 充值 ─────────────────────────────────────────────────────
  { path: '/pages/recharge/rechargeList',   redirect: '/pages/recharge/rechargePage' },
  { path: '/pages/recharge/rechargeSubmit', redirect: '/pages/recharge/rechargePage' },
  { path: '/pages/recharge/rechargePage',   component: () => import('@/pages/recharge/rechargePage.vue') },

  // ── 登录 / 注册 ───────────────────────────────────────────────
  { path: '/pages/login/login',    component: () => import('@/pages/login/login.vue') },
  { path: '/pages/login/register', component: () => import('@/pages/login/register.vue') },
  { path: '/pages/login/reset',    component: () => import('@/pages/login/reset.vue') },

  // ── 通知 ─────────────────────────────────────────────────────
  { path: '/pages/notice/noticeList',   component: () => import('@/pages/notice/noticeList.vue') },
  // { path: '/pages/notice/noticeDetail', component: () => import('@/pages/notice/noticeDetail.vue') },


  // ── 公司简介 ──────────────────────────────────────────────────
  { path: '/pages/company/profile', component: () => import('@/pages/company/profile.vue') },

  // ── 资产历史 ──────────────────────────────────────────────────
  { path: '/pages/assets/history', component: () => import('@/pages/assets/history.vue') },
  { path: '/pages/balance/index', component: () => import('@/pages/balance/index.vue') },
  { path: '/pages/balance/orders', component: () => import('@/pages/balance/orders.vue') },
  { path: '/pages/team/report', component: () => import('@/pages/team/report.vue') },
  { path: '/pages/team/daily', component: () => import('@/pages/team/daily.vue') },
  { path: '/pages/lottery/index', component: () => import('@/pages/lottery/index.vue') },

  // 404 fallback
  { path: '*', redirect: '/pages/index/index' }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

const publicPaths = new Set([
  '/pages/login/login',
  '/pages/login/register',
  '/pages/login/reset'
])

const guestOnlyPaths = new Set(['/pages/login/login', '/pages/login/register'])

router.beforeEach((to, from, next) => {
  const token = String(localStorage.getItem('token') || '').trim()

  if (!token && !publicPaths.has(to.path)) {
    next({
      path: '/pages/login/login',
      query: { redirect: to.fullPath },
      replace: true
    })
    return
  }

  if (token && guestOnlyPaths.has(to.path)) {
    next({ path: '/pages/index/index', replace: true })
    return
  }
  next()
})

// 将 router 注入 uni 兼容层，使 uni.navigateTo 等 API 生效
setRouter(router)

export default router
